const fixAccessibility = () => {
    document.querySelectorAll('[aria-hidden="true"]').forEach(el => {
        el.querySelectorAll('a, button, [role="button"]').forEach(child => {
            child.setAttribute('tabindex', '-1');
        })
    })
}
new MutationObserver(() => {
    fixAccessibility();
}).observe(document.body, { childList: true, subtree: true });
